import { Pie } from '../../config/BaseCharts'

export default {
    extends: Pie,
    props: {
        data: {
            type: Object,
            default: {},
        }
    },
    mounted() {
        this.renderChart(this.data, { responsive: true, maintainAspectRatio: false })
    },
    watch: {
        'data'(newVal) {
            this.renderChart(newVal, { responsive: true, maintainAspectRatio: false })
        }
    }
}